import { render, staticRenderFns } from "./recordPrize.vue?vue&type=template&id=4467eb12&scoped=true&"
import script from "./recordPrize.vue?vue&type=script&lang=js&"
export * from "./recordPrize.vue?vue&type=script&lang=js&"
import style0 from "./recordPrize.vue?vue&type=style&index=0&id=4467eb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467eb12",
  null
  
)

export default component.exports